var React = require( 'react' );
var createReactClass = require('create-react-class');
var MatrixRowItem = require('./matrixRowItem.jsx');

var MatrixRow = createReactClass({
  render: function() {

    var matrixCells = this.props.choices.map(function(choice, key) {
        var checked = Object.keys(this.props.userResponse).length > 0 && +this.props.userResponse.value === choice.value;

      return (
        <MatrixRowItem
          name={this.props.name + '_' + choice.tag}
          label={this.props.label + '_' + choice.label}
          key={this.props.name + '-choice-' + key}
          value={choice.value}
          rowValue={this.props.rowValue}
          checked={checked}
          handleResponse={this.props.handleResponse} />
      );
    }.bind(this));

    return (
      <div className="option-row">
          <div className="title">
            <h4>{this.props.label.slice(0, 23)}</h4>
          </div>
          {matrixCells}
      </div>
    );
  }
});

module.exports = MatrixRow;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/matrix/matrixRow.jsx